// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"14e2ff1f","453":"983c6822"}[chunkId] + ".chunk.js";
};